var map = {
	"./dinot/dinotitalic.woff2": 83,
	"./dinot/dinotmedium.woff2": 84,
	"./dinot/dinotregular.woff2": 85,
	"./garamond/AGaramondPro-Italic.woff2": 86,
	"./garamond/AGaramondPro-Regular.woff2": 87,
	"./garamond/AGaramondPro-Semibold.woff2": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;